/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponse
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponse {
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponse
     */
    billingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponse
     */
    canUsePoint?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponse
     */
    benepoAmountTotal?: number;
}

export function JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponseFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponse {
    return JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponseFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'billingAmount': !exists(json, 'billingAmount') ? undefined : json['billingAmount'],
        'canUsePoint': !exists(json, 'canUsePoint') ? undefined : json['canUsePoint'],
        'benepoAmountTotal': !exists(json, 'benepoAmountTotal') ? undefined : json['benepoAmountTotal'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponseToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'billingAmount': value.billingAmount,
        'canUsePoint': value.canUsePoint,
        'benepoAmountTotal': value.benepoAmountTotal,
    };
}

